import {
    Block,
    FileBlock,
    IBlockProcessor
} from 'src/shared/wysiwyg/ultra/UltraBlockProcessing/UltraBlockInterfaces';
import { UnsupportedBlockError } from 'src/shared/wysiwyg/ultra/UltraBlockProcessing/UnsupportedBlockError';

export class FileBlockProcessor implements IBlockProcessor<FileBlock> {

    protected readonly container: HTMLElement;

    constructor(container: HTMLElement) {
        this.container = container;
    }

    async process(block: Block): Promise<string> {
        throw new UnsupportedBlockError(`File blocks are not yet supported : ${ block.id}`);
    }
}
